export default "__VITE_PUBLIC_ASSET__8bc879d2__"